export default "__VITE_ASSET__BC_oG2ry__"